import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="27272" className="hidden md:flex gap-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-20 bg-muted/30 animate-pulse rounded-none" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group relative text-sm font-semibold tracking-tight text-primary/80 hover:text-primary transition-colors py-2 uppercase">
                {item.label}
                <span className="absolute left-0 bottom-0 h-[2px] w-0 bg-accent transition-all duration-300 group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 p-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-full bg-muted/30 animate-pulse rounded-none" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-2 p-4">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="block py-3 text-lg font-bold tracking-tight text-primary border-b border-border/60 hover:text-accent hover:pl-2 transition-all uppercase" onClick={onClose}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function HeaderNavigazione() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="intestazione" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background text-foreground mb-4 ${isScrolled ? "bg-background/90 backdrop-blur-md border-b border-secondary/20 shadow-md py-3" : "bg-background border-b border-muted py-5"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between">
          {}
          <Link to="/" className="flex items-center gap-2 z-50 relative">
            <img src="https://studiomess.it/wp-content/uploads/2026/03/LOGO-BLU-grande-scaled.png" alt="Studio MESS S.r.l. - Ingegneria Sicura" className="h-12 object-contain" />
          </Link>

          {}
          <div className="hidden md:block">
            <MenuProvider menu_id="42">
              <DesktopMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:hidden z-50">
            <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-primary hover:bg-muted/50 rounded-none" aria-label="Toggle menu">
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className={`fixed inset-0 bg-background/98 backdrop-blur-xl z-40 md:hidden transition-all duration-300 ease-in-out ${isMobileMenuOpen ? "opacity-100 pointer-events-auto translate-x-0" : "opacity-0 pointer-events-none translate-x-full"}`} style={{
      top: "0px"
    }}>
        <div className="flex flex-col h-full pt-24 px-6 pb-8 overflow-y-auto">
          <MenuProvider menu_id="42">
            <MobileMenuConsumer onClose={() => setIsMobileMenuOpen(false)} />
          </MenuProvider>
          
          <div className="mt-auto pt-8 border-t border-border/60">
             <p className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-4">
               Consulenza Tecnica Specializzata
             </p>
             <Button asChild className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-none font-bold uppercase tracking-tight">
               <Link to="#richiedi-consulenza">
                 Richiedi una consulenza
               </Link>
             </Button>
          </div>
        </div>
      </div>
    </header>;
}